<template>
  <div class="container-main-content">
    <div class="content-inner">
      <Header />
      <div class="content-inner__body">
        <h4 class="content-inner__body-title mb-2">
          Email này đã được sử dụng bởi một tài khoản khác
        </h4>
        <p class="f14 mb-4">Vui lòng thử lại hoặc tạo tài khoản khác</p>
        <button type="button" class="btn btn-primary" @click="handleSignup">
          ĐĂNG KÝ TÀI KHOẢN KHÁC
        </button>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      currentQueries: window.location.href.includes("?")
        ? window.location.href.substring(window.location.href.indexOf("?"))
        : "",
    };
  },
  methods: {
    handleSignup() {
      this.$router.push({
        path: `/signup${this.currentQueries}`,
      });
    },
  },
};
</script>

<style>
.bg-main {
  display: block;
}
</style>
